'use client';

import { FC, useEffect } from 'react';
import Contact from './Contact';
import ContactForm from './ContactForm';
import { LanguageCode } from '@/hotdesk-ui/constants/langulage.constant';
import { firebaseAnalytics } from '@/hotdesk-ui/common-classes/firebase.service';
interface ContactClientWrapperProps {
  languageCode: LanguageCode;
}
const ContactClientWrapper: FC<ContactClientWrapperProps> = ({
  languageCode
}) => {
  useEffect(() => {
    firebaseAnalytics('page_view', {
      page_name: 'contact_sales'
    });
  }, []);
  return <>
            <div>
                <ContactForm languageCode={languageCode} data-sentry-element="ContactForm" data-sentry-source-file="contactClientWrapper.tsx" />
            </div>
            <Contact data-sentry-element="Contact" data-sentry-source-file="contactClientWrapper.tsx" />
        </>;
};
export default ContactClientWrapper;